import React from 'react';
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare
import {
  VerticalTimeline,
  VerticalTimelineElement,
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-redeclare
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { BidStatus } from '../../services';
import {
  BidHistoryPanel,
  BidHistoryPanelContainer,
  BidHistoryPanelHeader,
  BidHistoryPanelHeaderTitle,
} from './BidHistory.styled';
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare
import { Icons } from '@sede-enterprise/shell-ds-react-framework';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store';
import { useTheme } from 'styled-components';
import { ClearSubmissionHistory, IApplicationState } from '../../store';
import { getAuctionTimezone } from '../../core';


export const onHistoryTimelineColor = (status: string) => {
  switch (status) {
    case BidStatus.Accepted:
      return 'vertical-timeline-element--accepted';
    case BidStatus.Rejected:
      return 'vertical-timeline-element--rejected';
    default:
      return 'vertical-timeline-element--open';
  }
};

export const onHistoryContentColor = (status: string) => {
  switch (status) {
    case BidStatus.Accepted:
      return 'vertical-timeline-element-title--accepted';
    case BidStatus.Rejected:
      return 'vertical-timeline-element-title--rejected';
    default:
      return 'vertical-timeline-element-title--open';
  }
};

export interface IBidHistoryProps {
  biddingOpen?: Date;
}

const BidHistory: React.FC<IBidHistoryProps> = (props) => {
  // const [showHistoryPanel, setShowHistoryPanel] = useState(false);
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const bidHistory = useSelector(
    (state: IApplicationState) => state.bidHistory
  );

  return (
    <BidHistoryPanel open={bidHistory.isOpen}>
      <BidHistoryPanelHeader className='bidHistory'>
        <BidHistoryPanelHeaderTitle>History</BidHistoryPanelHeaderTitle>
        <Icons.Cross 
        className='crossIcon'
        height={25} 
        width={30} 
        onClick={() => {
          dispatch(ClearSubmissionHistory());
        }} />
      </BidHistoryPanelHeader>
      <BidHistoryPanelContainer>
        <VerticalTimeline
          layout={'1-column-left'}
          animate={false}
          className='vertical-timeline-custom-line'
        >
          <VerticalTimelineElement
            className='vertical-timeline-element--open'
            contentStyle={{
              background: '#181C21',
              color: '#fff',
            }}
            contentArrowStyle={{
              borderRight: `7px solid  #181C21`,
            }}
            date={props.biddingOpen ? moment(props.biddingOpen)
              .tz(getAuctionTimezone())
              .format('DD MMM yyyy HH:mm:ss'): ''}
            iconStyle={{ background: '#181C21' }}
          >
            <span className='vertical-timeline-element-title--open'>
              Bidding open
            </span>
          </VerticalTimelineElement>
          {!bidHistory?.submissionHistory?.loading &&
            bidHistory?.submissionHistory?.submissionHistoryItems &&
            bidHistory?.submissionHistory.submissionHistoryItems.map((x) => {
              return (
                <VerticalTimelineElement
                  className={onHistoryTimelineColor(x.submissionStatus)}
                  contentStyle={{
                    background: '#181C21',
                    color: '#fff',
                  }}
                  contentArrowStyle={{
                    borderRight: `7px solid  #181C21`,
                  }}
                  date={moment(x.createdDateTime)
                    .tz(getAuctionTimezone())
                    .format('DD MMM yyyy HH:mm:ss')}
                  iconStyle={{ background: '#181C21' }}
                >
                  <span className={onHistoryContentColor(x.submissionStatus)}>
                    {`v${x.version} ${x.submissionStatus}`}
                  </span>
                </VerticalTimelineElement>
              );
            })}
        </VerticalTimeline>
      </BidHistoryPanelContainer>
    </BidHistoryPanel>
  );
};

export default BidHistory;
